<template>
  <el-card
      class="item-card"
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec;"
      body-style="margin: 8px;">
    <div
        class="flex flex-row"
        style="margin: 8px 8px 8px 8px">
      <img
          v-if="devicePicture && devicePicture.src"
          style="width: 80px; height: 80px"
          :alt="devicePicture.alt"
          :src="devicePicture.src">
      <div
          class="flex-1"
          style="margin: 7px">
        <div class="flex flex-row">
          <div
              class="item-name flex-1"
              style="margin-top: 7px !important;">
            {{ title }}
          </div>
          <div
              v-if="quantity>1"
              class="flex-1"
              style="margin-top: 8px;">
            x{{ quantity }}
          </div>
        </div>
        <div class="item-sku">
          <strong>ASIN: </strong>&nbsp;{{ sku }}
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  name: "ShippingDetails",
  props: {
    shipmentData: {
      type: Object,
      default: () => {
        return [];
      },
    },
    title: {
      type: String,
      default: "NA",
    },
    deviceType: {
      type: String,
      default: "doorbell",
    },
    sku: {
      type: String,
      default: "NA",
    },
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    devicePicture() {
      return this.images[0];
    },
  },
};
</script>

<style>
.item-card {
  margin-right: 16px;
}
.item-name {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.item-sku {
  height: 24px;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  color: #6e6e6e;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin-top: 2px;
}
</style>
